import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getPublicCollectionOverview,
  getPublicCollections,
  getPublicCollectionsSource,
} from "../services/use-public-collection.service";

const useCollection = (filter, setLoading) => {
  const [publicCollections, setPublicCollections] = useState([]);
  const [publicCollectionsSource, setPublicCollectionsSource] = useState([]);

  const [filteredPublicCollections, setFilteredPublicCollection] = useState([]);

  const abortControllerRef = useRef(null);
  const { user } = useSelector((state) => state.auth);
  const params = useParams();

  const getPublicCollection = async () => {
    try {
      setLoading?.(true);
      const data = await getPublicCollections(user, "");
      setPublicCollections(data);
      return data;
    } catch (e) {
      console.error(e);
    } finally {
      setLoading?.(false);
    }
  };

  const fetchPublicCollectionsSource = async (id) => {
    if (!id) return;
    try {
      setLoading?.(true);
      const data = await getPublicCollectionsSource(user, id);
      setPublicCollectionsSource(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading?.(false);
    }
  };

  const handlePublicCollectionOverview = async (id) => {
    try {
      const data = getPublicCollectionOverview(user, id);
      return data;
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getPublicCollection();
  }, [params.id]);

  useEffect(() => {
    abortControllerRef.current?.abort();
    abortControllerRef.current = new AbortController();
    const signal = abortControllerRef.current.signal;

    const fetchFiltered = async () => {
      setLoading?.(true);
      try {
        const data = await getPublicCollections(user, filter, signal);
        if (!signal.aborted) {
          setFilteredPublicCollection(data);
        }
        return data;
      } catch (e) {
        if (e.name !== "AbortError") {
          console.error(e);
        }
      } finally {
        if (!signal.aborted) {
          setLoading?.(false);
        }
      }
    };

    fetchFiltered();

    return () => {
      abortControllerRef.current?.abort();
    };
  }, [filter]);

  return {
    publicCollections,
    fetchPublicCollectionsSource,
    publicCollectionsSource,
    handlePublicCollectionOverview,
    filteredPublicCollections,
  };
};

export default useCollection;
